import {
  clearAuthToken,
  clearAuthTokens,
  clearRefreshToken,
  extractAuthPayload,
  getAuthToken,
  getRefreshToken,
  setAuthToken,
  setRefreshToken,
  isSuccessResponse,
} from "lib/api";

export {
  clearAuthToken,
  clearAuthTokens,
  clearRefreshToken,
  extractAuthPayload,
  getAuthToken,
  getRefreshToken,
  setAuthToken,
  setRefreshToken,
  isSuccessResponse,
};

/**
 * Persisted profile must include `id` or `_id` (APIs differ); token alone is insufficient.
 */
export function authUserDataHasId(userData) {
  if (!userData || typeof userData !== "object") return false;
  const id = userData._id ?? userData.id;
  if (id === null || id === undefined) return false;
  if (typeof id === "string") return id.trim() !== "";
  return true;
}

/**
 * Current AuthUser slice `data` (lazy store read avoids import cycle with reducer).
 */
export function getAuthUser() {
  const { store } = require("../store/storeIndex");
  return store.getState()?.AuthUser?.data ?? {};
}

/** True when access token and persisted user `id` / `_id` are both present. */
export function isAuthenticated() {
  const token = getAuthToken();
  return Boolean(token && authUserDataHasId(getAuthUser()));
}
